import React from 'react';

import styles from './styles.module.scss';

const ColumnContainer = ({
  disclaimer,
  title,
  titleDescription,
  smallIcon,
  headerRight,
  isCommingSoon = false,
  children
}) => {
  return (
    <div className={styles.column}>
      <div className={styles.titleContainer}>
        <h3 className={styles.columnTitle}>
          {smallIcon}

          {disclaimer && <div className={styles.disclaimer}>{disclaimer}</div>}
          {title || ''}
          <div className={styles.titleBold}>{titleDescription || ''}</div>
        </h3>
        {isCommingSoon && <span className={styles.soonLabel}>Coming Soon</span>}
        {headerRight && (
          <div className={styles.headerRightAction}>Updated {headerRight}</div>
        )}
      </div>
      <div className={styles.cardWrapper}>
        <div className={styles.card}>{children}</div>
      </div>
    </div>
  );
};

export default ColumnContainer;
